module.exports = __webpack_public_path__ + "static/img/81.c146ab73.png";